import type { ReactElement } from 'react';
import { Alert } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { RuleSeverity } from '@billing/validation/rules';
import type { RuleTranslate } from './constants';

export const RuleAlertPreview = ({
  severity,
  message,
  translate,
}: {
  severity: RuleSeverity;
  message: string;
  translate: RuleTranslate;
}): ReactElement => {
  const block = severity === RuleSeverity.Block;
  const color = block ? 'red' : 'yellow';
  return (
    <Alert
      color={color}
      icon={<IconAlertTriangle size={18} />}
      bd={`1px solid ${color}.6`}
      title={
        block
          ? translate('pages:rules.builder.blockPreview')
          : translate('pages:rules.builder.warnPreview')
      }
    >
      {message.trim() || translate('pages:rules.builder.previewPlaceholder')}
    </Alert>
  );
};
